module.exports = __webpack_public_path__ + "img/other-option.svg";